"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onlyTruthyValues = void 0;
const onlyTruthyValues = (obj) => {
    return Object.entries(obj).reduce((acc, [key, value]) => {
        if (value) {
            acc[key] = value;
        }
        return acc;
    }, {});
};
exports.onlyTruthyValues = onlyTruthyValues;
//# sourceMappingURL=object-utils.js.map